/* ============================================================
   OOO LP: Saffron Listicle — interactive behaviours.
   Depends on: ooo-motion.js (scroll reveal), ooo-cart.js (AJAX cart).
   Both are loaded globally via ooo-head.liquid (defer), so this
   script is safe to load after them.
   ============================================================ */

(function () {
  'use strict';

  // ── 1. Purchase option toggle (subscribe / one-time) ────────
  document.querySelectorAll('.ooo-lp-saffron-pcard').forEach(function (card) {
    var opts = card.querySelectorAll('.ooo-lp-saffron-opt');
    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        // swap variant id on the hidden form input
        var variantInput = card.querySelector('[name="id"]');
        if (variantInput) {
          variantInput.value = opt.dataset.variantId || '';
        }
      });
    });
  });

  // ── 2. Thumbnail carousel arrows ────────────────────────────
  document.querySelectorAll('.ooo-lp-saffron-buy__carousel').forEach(function (carousel) {
    var rail = carousel.querySelector('.ooo-lp-saffron-buy__rail');
    var prev = carousel.querySelector('[data-ooo-prev]');
    var next = carousel.querySelector('[data-ooo-next]');
    if (!rail) return;
    function stepWidth() {
      var thumb = rail.querySelector('.ooo-lp-saffron-buy__thumb');
      return thumb ? thumb.getBoundingClientRect().width + 12 : 122;
    }
    if (prev) {
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -stepWidth(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        rail.scrollBy({ left: stepWidth(), behavior: 'smooth' });
      });
    }
  });

  // ── 3. Add-to-bag intercept ──────────────────────────────────
  // ooo-cart.js auto-intercepts <form action*="/cart/add">.
  // Nothing extra needed here — graceful no-op when variant id blank.

})();
